import { render, staticRenderFns } from "./CreateTemplateProject.vue?vue&type=template&id=7e5ce1c5"
import script from "./CreateTemplateProject.vue?vue&type=script&lang=js"
export * from "./CreateTemplateProject.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateProject.vue?vue&type=style&index=0&id=7e5ce1c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports